import React, { Component } from 'react'
import { Button, Form, Radio, Input, Tag, Row, Col, Icon } from 'antd'
import { compose, graphql, withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
// import queryString from 'query-string'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
// import _intersect from 'lodash/intersect'
import moment from 'moment'

import { FormattedMessage, injectIntl } from 'react-intl'

import RegistrationSteps from '~/App/components/RegistrationSteps'
import eventFromSlugQuery from '~/App/graphql/queries/eventFromSlug.gql'
import checkGroupNameAvailableQuery from '~/App/graphql/queries/checkGroupNameAvailable.gql'
import createRegistrationMutation from '~/App/graphql/mutations/createRegistration.gql'
import createParticipantMutation from '~/App/graphql/mutations/createParticipant.gql'
import verifyCouponCodeQuery from '~/App/graphql/queries/verifyCouponCode'

import './styles.css'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: {
      span: 6,
      offset: 6
    }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: {
      span: 6
    }
  }
}

class EventRegister extends Component {
  state = {
    submitting: false
  }
  handleCreateRegistration = e => {
    e.preventDefault()
    const { form: { validateFields }, createRegistration, history } = this.props
    validateFields({ force: true }, (err, data) => {
      // console.log({err, data})
      const { record } = data

      // const { _id: eventId, registrationTypes } = event
      // const regType = registrationTypes.find(regType => regType._id === record.registrationTypeId)
      // console.log(data)
      // return
      if (!err) {
        this.setState({
          submitting: true
        })
        createRegistration({
          variables: {
            record
          }
        }).then(res => {
          const registrationId = _get(res, 'data.registerEvent.record._id')
          if (registrationId) {
            history.push(`/reg/${registrationId}/edit?pId=new`)
          }
        })
        // createRegistration({
        //   variables: {
        //     record
        //   }
        // }).then(res => {
        //   const registrationId = _get(res, 'data.registerEvent.record._id')
        //   let createParticipants$ = [] // TODO: should handle server side
        //   if (regType.minParticipants) {
        //     createParticipants$ = [...Array(regType.minParticipants)].map(() => {
        //       return createParticipant({
        //         variables: {
        //           record: {
        //             registrationId,
        //             eventId,
        //             profile: {}
        //           }
        //         }
        //       })
        //     })
        //   }
        //   Promise.all(createParticipants$).then(() => {
        //     if (registrationId) {
        //       history.push(`/reg/${registrationId}/edit?pId=new`)
        //     }
        //   })
        // })
      }
    })
  }

  groupNameValidator = (rule, value, callback) => {
    const { client, intl, data } = this.props
    const eventId = _get(data, 'event._id')
    // console.log({ value })
    if (!value) return callback()
    client.query({
      query: checkGroupNameAvailableQuery,
      fetchPolicy: 'network-only',
      variables: {
        eventId,
        groupName: value
      }
    }).then(({ data: { checkGroupNameAvailable } }) => {
      // console.log({ checkGroupNameAvailable })
      checkGroupNameAvailable ? callback() : callback(
        intl.formatMessage({
          id: 'app.groupNameUnavailable',
          defaultMessage: 'Group Name not Available'
        })
      )
    })
  }

  handleCouponCodeTextChange = () => e => {
    const { resetFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    resetFields([
      `record.couponCodeIds`
    ])
  }

  checkCouponCode = () => {
    const { validateFields } = this.props.form
    // const regTypeId = getFieldValue('registrationTypeId')
    validateFields(
      [
        `__couponCodeText`
      ],
      { force: true }
    )
  }

  couponCodeValidator = (rule, value, callback) => {
    // const { search } = this.props.location
    // const { l: locale = 'en' } = queryString.parse(search)
    // console.log({ rule, value })
    const { i18n: { locale } } = this.props
    if (!value) return callback()
    // const { fullField } = rule
    // const [, groupIndex] = fullField.split('.')
    const {
      form: { getFieldValue, setFieldsValue, resetFields },
      client,
      data,
      intl
    } = this.props
    const eventId = _get(data, 'event._id')
    // console.log({ eventId })
    client
      .query({
        query: verifyCouponCodeQuery,
        fetchPolicy: 'network-only',
        variables: {
          code: value,
          eventId
        }
      })
      .then(
        ({ data: { verifyCouponCode } }) => {
          // console.log({verifyCouponCode})
          const registrationTypeId = getFieldValue(
            `record.registrationTypeId`
          )
          const { _id, couponCodeType: { masterIds, name } } = verifyCouponCode
          // console.log(productTypeIds, registrationTypeId)
          // const registrationType = registrationTypes.find(tt => tt._id === registrationTypeId)
          // console.log({ masterIds, registrationTypeId, _id })
          if (masterIds.includes(registrationTypeId)) {
            setFieldsValue({
              [`__couponCodeInfo`]: (
                <span>
                  <Icon type="check-circle" /><em>{value}: {name[locale]}</em>
                </span>
              ),
              [`record.couponCodeIds`]: [_id]
            })
            callback()
          } else {
            const message = 'Incorrect registration type'
            callback(message)
          }
        },
        e => {
          // console.dir(e)
          if (e.graphQLErrors) {
            resetFields([`__couponCodeInfo`])
            e.graphQLErrors.forEach(error => callback(
              intl.formatMessage({ id: `api.${error.message}`, defaultMessage: '' })
            ))
            // callback(e.graphQLErrors)
          } else {
            callback()
          }
          // message.error(e.message)
        }
      )
  }

  render () {
    const { data, form, i18n: { locale }, intl, showHiddenTypes } = this.props
    // console.log({ showHiddenTypes })
    const { getFieldDecorator, getFieldValue } = form
    // getFieldsError
    const event = _get(data, 'event')
    if (data.loading) {
      return <div>Loading...</div>
    }
    if (!event) {
      return <div>Event not found</div>
    }
    const periods = _get(event, 'periods', [])
    // const currentPeriod = periods.find(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // const currentPeriods = periods.filter(period =>
    //   moment().isBetween(period.start, period.end)
    // )
    // showHiddenTypes -> hidden
    // !show -> !hidden
    // console.log(_get(data, 'event.registrationTypes', []))
    const registrationTypes = _get(event, 'registrationTypes', []).filter(type =>
      periods &&
      type.periodIds.map(id =>
        periods.find(p => p._id === id)
      ).find(p =>
        p && (moment().isBetween(p.start, p.end) || moment().isBetween(p.preRegisterStart, p.preRegisterEnd))
      )
    ).filter(type => !!showHiddenTypes !== !type.hidden)
    // console.log({ registrationTypes }, _get(event, 'registrationTypes'))
    // const hasRegTypes = registrationTypes.length > 0
    let $registrationTypes
    let $registrationFields
    getFieldDecorator('record.eventId', {
      initialValue: _get(data, 'event._id')
    })
    const registrationFields = _get(data, 'event.settings.registration.fields', []) || []
    const regFields = registrationFields
      .filter(f => f.enabled)
      .reduce((result, field) => {
        result[field.name] = field
        return result
      }, {})
    const ticketsQuota = _get(event, 'ticketsQuota', [])
    const ticketLimitReached = ticketsQuota.reduce((result, rec) => {
      result[rec._id] = rec.limit > 0 && rec.count >= rec.limit
      return result
    }, {})
    const regTypeDecorator = getFieldDecorator('record.registrationTypeId', {
      initialValue: registrationTypes.length === 1 ? _get(registrationTypes, [0, '_id']) : null,
      rules: [
        { required: true, message: 'Please select registration Type' }
      ]
    })
    const regTypeId = getFieldValue('record.registrationTypeId')
    const regType = registrationTypes.find(t => t._id === regTypeId)
    const couponCodeEnabled = _get(regType, 'couponCodeEnabled')
    const couponCodeRequired = _get(regType, 'couponCodeRequired')
    // console.log({ couponCodeRequired })
    getFieldDecorator('record.couponCodeIds', { initialValue: [] })
    // if (hasRegTypes) {
    $registrationTypes = (
      <Form.Item label={<FormattedMessage id="app.registrationType" defaultMessage="Registration Type" />} {...formItemLayout}>
        {regTypeDecorator(
          <Radio.Group>
            {_sortBy(registrationTypes, ['_id']).map(regType => {
              // console.log(regType.limitId)
              const full = regType.limitId && ticketLimitReached[regType.limitId]
              return <Radio
                className="registrationTypeRadio"
                key={regType._id}
                value={regType._id}
                disabled={full}
                style={{ marginBottom: '.5em' }}
              >
                <span className="registrationTypeItem">
                  {full && <Tag color="red">
                    {{ en: 'Full', th: 'เต็ม' }[locale]}
                  </Tag>} {regType.name[locale]}
                </span>
                <br />
                <span className="registrationTypeInfo"
                  style={{
                    display: 'inline-block',
                    lineHeight: '1.5em',
                    whiteSpace: 'pre-line',
                    marginLeft: '2em',
                    color: 'grey',
                    margiLeft: '2.25em',
                    marginTop: '-.5em'
                  }}
                >{_get(regType, ['infoMessage', locale])}</span>
              </Radio>
            })}
          </Radio.Group>
        )}
      </Form.Item>
    )
    $registrationFields = (
      <div>
        {regFields['groupName'] &&
          <Form.Item label={<FormattedMessage id="app.groupName" defaultMessage="Group Name" />} {...formItemLayout}>
            {getFieldDecorator('record.groupName', {
              // validateTrigger: ['onChange'],
              validateTrigger: ['onBlur'],
              validateFirst: true,
              rules: [{
                required: regFields['groupName'].required, message: intl.formatMessage({ id: 'app.groupNameEmpty', defaultMessage: 'Group Name Empty' })
              }, {
                validator: this.groupNameValidator // TODO: only unique
              }]
            })(<Input />)}
          </Form.Item>
        }
      </div>
    )
    const couponCodeText = getFieldValue(
      `__couponCodeText`
    )
    getFieldDecorator(`__couponCodeInfo`)
    const couponCodeInfo = getFieldValue(
      `__couponCodeInfo`
    )
    // }
    return <Form onSubmit={this.handleCreateRegistration} style={{ padding: '26px' }} className="EventRegisterPage">
      <div className="eventDetails" style={{ paddingTop: '85px', display: 'flex', justifyContent: ' center' }}>
        <div className="eventTitle">
          {_get(data, ['event', 'name', locale])}
        </div>
      </div>
      <div style={{ maxWidth: '1000px', margin: 'auto' }}>
        <RegistrationSteps step="register" />
        <div style={{ padding: '26px', background: 'white', borderRadius: '0 0 8px 8px' }}>
          {$registrationTypes}
          {$registrationFields}
          {couponCodeEnabled &&
            <Form.Item label={{ en: 'Code', th: 'Code' }[locale]}
              {...formItemLayout}
              extra={couponCodeInfo}
            >
              <Row gutter={8}>
                <Col span={18}>
                  {getFieldDecorator(
                    `__couponCodeText`,
                    {
                      validateTrigger: [],
                      rules: [{
                        required: couponCodeRequired, message: intl.formatMessage({ id: 'app.couponCodeRequired', defaultMessage: 'Please enter Code' })
                      }, {
                        validator: this.couponCodeValidator
                      }],
                      onChange: () =>
                        this.handleCouponCodeTextChange()
                    }
                  )(<Input />)}
                </Col>
                <Col span={6}>
                  <Button disabled={!couponCodeText} onClick={e => this.checkCouponCode()}>
                    Check
                  </Button>
                </Col>
              </Row>
            </Form.Item>}
          <div style={{ padding: '8px', textAlign: 'center' }}>
            {_get(data, ['event', 'settings', 'registrationType', 'customMessage', locale])}
          </div>
          <div style={{ padding: '8px', textAlign: 'right' }}>
            <Button type="primary" htmlType="submit" loading={this.state.submitting}>
              <FormattedMessage id="app.next" defaultMessage="Next"/>
            </Button>
          </div>
        </div>
      </div>
      {/* <Button htmlType="submit">Submit</Button> */}
    </Form>
  }
}

export default compose(
  Form.create(),
  withApollo,
  graphql(eventFromSlugQuery, {
    options: ({ match: { params: { eventSlug } } }) => ({
      variables: { slug: eventSlug },
      fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, eventFromSlug } }) => ({
      data: {
        loading,
        event: eventFromSlug
      }
    })
  }),
  graphql(createRegistrationMutation, {
    name: 'createRegistration'
  }),
  graphql(createParticipantMutation, {
    name: 'createParticipant'
  }),
  inject('i18n'),
  injectIntl,
  observer
)(EventRegister)



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/EventRegister/EventRegister.js